<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <ul v-for="companySetting in companySettings"
        :key="companySetting.to.name"
        class="menu-list">
        <li>
          <router-link :to="companySetting.to"
            active-class="is-active"
            exact>
            <span>
              {{ companySetting.label }}
            </span>
          </router-link>
        </li>
      </ul>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import SuperadminCompanyRoutes from '../../views/superadmin/company/route-types'

export default {
  name: 'CompanySideMenu',
  components: {
    AppSideMenu
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    isNew() {
      const { companyId } = this.$route.params
      return companyId === 'new'
    },
    isHQ() {
      if (this.isNew) {
        const { companyType } = this.$route.params
        return companyType === 'hq'
      } else {
        var company = this.$store.getters['companysetting/company']
        return company && company.isHq === true
      }
    },
    companySettings() {
      const { companyId, companyType } = this.$route.params
      const allSettings = [
        {
          to: { name: SuperadminCompanyRoutes.CompanyDetail.name, params: { companyId, companyType } },
          label: 'Detail',
          isShow: true
        },
        // {
        //   to: { name: SuperadminCompanyRoutes.CompanyNewUser.name, params: { companyId, companyType } },
        //   label: 'Default Administrator',
        //   isShow: this.isNew
        // },
        {
          to: { name: SuperadminCompanyRoutes.CompanyLicense.name, params: { companyId, companyType } },
          label: 'License',
          isShow: !this.isHQ && !this.isNew
        },
        {
          to: { name: SuperadminCompanyRoutes.CompanyModules.name, params: { companyId, companyType } },
          label: 'Modules',
          isShow: !this.isHQ && !this.isNew
        },
        {
          to: { name: SuperadminCompanyRoutes.CompanyItemCategory.name, params: { companyId, companyType } },
          label: 'Item Category',
          isShow: !this.isHQ && !this.isNew
        },
        {
          to: { name: SuperadminCompanyRoutes.CompanyExternal.name, params: { companyId, companyType } },
          label: 'External Setting',
          isShow: !this.isHQ && !this.isNew
        }
      ]
      return allSettings.filter((item) => item.isShow)
    }
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>